import { render } from "./brick-table.vue?vue&type=template&id=be17ead2&scoped=true"
import script from "./brick-table.vue?vue&type=script&lang=js"
export * from "./brick-table.vue?vue&type=script&lang=js"

import "./brick-table.vue?vue&type=style&index=0&id=be17ead2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be17ead2"]])

export default __exports__